// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQueryWithOffset } from '@hooks/other/useQueryWithOffset';
import { UseQueryResult } from '@tanstack/react-query';
import { CollateralAgreementChangeRequest } from '@daml.js/utility-collateral-app-v1/lib/Utility/Collateral/App/Model/Collateral';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import TemplateContract from '../../../../utils/TemplateContract';

const useCollateralAgreementChangeRequests: () => UseQueryResult<
  TemplateContract<CollateralAgreementChangeRequest>[],
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  return useQueryWithOffset({
    queryKey: ['queryCollateralAgreementChangeRequests'],
    queryFn: async (_, offset) => {
      return ledgerApi.queryCollateralAgreementChangeRequests(offset);
    },
  });
};

export default useCollateralAgreementChangeRequests;
